export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/sleep-green-apple.f225c952c3b7c02c96ff4f722551ea5d.png";